module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_is-object.js
// module id = 29
// module chunks = 0 2 3 4 5 6 7 8 11 12 13 14 15 16 17 18 20